import { render, staticRenderFns } from "./InsuranceItem.vue?vue&type=template&id=7f660324&scoped=true&"
import script from "./InsuranceItem.vue?vue&type=script&lang=js&"
export * from "./InsuranceItem.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceItem.vue?vue&type=style&index=0&id=7f660324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f660324",
  null
  
)

export default component.exports